var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.source === 'mdi')?_c('v-icon',_vm._b({},'v-icon',_vm.$attrs,false),[_vm._v(_vm._s(_vm.name))]):(_vm.source === 'custom')?_c('span',_vm._b({class:_vm.customIconClass},'span',_vm.$attrs,false)):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }